import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Theme } from 'src/theme/types/createPalette';

export const useCampaignsStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: '100%',
      height: '100%',
      background: '#fff',
      minWidth: 600,
      overflow: 'auto',
    },
    header: {
      borderBottom: '1px solid #EAECF0',
      padding: 24,
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 24,
    },
    statsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
      padding: '24px 16px',
    },
    statsSection: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 16,
    },
    statsSectionTitle: {
      width: '100%',
      marginBottom: 4,
    },
    reportStatsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 32,
      padding: '24px 16px',
    },
    reportSectionsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: 32,
      alignItems: 'start',
    },
    reportSection: {
      border: '1px solid #EAECF0',
      borderRadius: 8,
      overflow: 'hidden',
      background: '#fff',
      width: '100%',
      minWidth: 0,
    },
    reportSectionHeader: {
      padding: '12px 16px',
      background: '#F9FAFB',
      borderBottom: '1px solid #EAECF0',
      fontWeight: 600,
      fontSize: 14,
      color: '#344054',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '&:hover': { background: '#F2F4F7' },
    },
    reportSectionBody: {
      padding: 16,
    },
    reportDate: {
      fontSize: 14,
      color: '#667085',
      marginBottom: 24,
    },
    statBlock: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      marginBottom: 16,
      '&:last-child': { marginBottom: 0 },
    },
    statBlockTitle: {
      fontSize: 13,
      fontWeight: 600,
      color: '#344054',
      marginBottom: 4,
    },
    statRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      padding: '6px 0',
      fontSize: 13,
      color: '#101828',
      borderBottom: '1px solid #F2F4F7',
      '&:last-child': { borderBottom: 'none' },
    },
    statRowLabel: {
      flex: 1,
      color: '#667085',
    },
    statRowValue: {
      fontWeight: 600,
      color: '#101828',
      minWidth: 80,
      textAlign: 'right',
    },
    statRowPercent: {
      color: '#667085',
      minWidth: 70,
      textAlign: 'right',
    },
    top10Table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: 13,
    },
    top10Row: {
      '& td': {
        padding: '8px 0',
        borderBottom: '1px solid #F2F4F7',
        color: '#101828',
        verticalAlign: 'top',
      },
      '&:last-child td': { borderBottom: 'none' },
    },
    top10Rank: {
      width: 28,
      color: '#667085',
      fontWeight: 600,
    },
    top10Name: {
      maxWidth: 400,
      color: '#101828',
    },
    top10ViolationReason: {
      maxWidth: 280,
      color: '#667085',
      fontSize: 12,
      paddingRight: 12,
    },
    top10Impressions: {
      textAlign: 'right',
      fontWeight: 600,
      color: '#344054',
    },
    emptyList: {
      fontSize: 13,
      color: '#98A2B3',
      fontStyle: 'italic',
      padding: '12px 0',
    },
    options: {
      display: 'flex',
      alignItems: 'center',
      padding: '0 16px',
      marginBottom: 24,
      gap: 8,
      flexWrap: 'wrap',
    },
    searchBar: {
      width: 320,
      border: '1px solid #D0D5DD',
      padding: '0 12px',
      borderRadius: 8,

      '& .MuiInputBase-root:before, & .MuiInputBase-root:after': {
        border: 'none !important',
      },
    },
    items: {
      width: '100%',
      overflow: 'scroll',
    },
    addBtn: {
      background: '#ffffff',
      border: '1px solid #D0D5DD',
      borderRadius: 8,
      height: 34,
      fontSize: 12,
      fontWeight: 600,
      color: 'rgb(52, 64, 84)',
    },
    downloadBtn: {
      background: '#ffffff',
      border: '1px solid #D0D5DD',
      borderRadius: 8,
      height: 34,
      fontSize: 12,
      fontWeight: 600,
      color: 'rgb(52, 64, 84)',
      width: 90,
    },
    closeIcon: {
      cursor: 'pointer',
      position: 'absolute',
      top: theme.spacing(2),
      right: theme.spacing(3),
    },
    modalContent: {
      height: 'calc(100vh - 105px)',
      maxHeight: 'calc(100vh - 105px)',
      overflow: 'auto',
    },
    description: {
      padding: '2px 14px',
      borderRadius: 8,
      border: '1px solid #C3C3C7',
      width: '100%',
      height: 36,

      '& .MuiInputBase-root:before, & .MuiInputBase-root:after': {
        border: 'none !important',
      },
    },
  })
);
